/* @ngInject */
const httpInterceptor = (
  $q,
  $rootScope
) => {
  let loadingCount = 0

  return {
    request: (config) => {
      if (++loadingCount === 1) $rootScope.$broadcast('loading:progress')
      return config || $q.when(config)
    },

    response: (response) => {
      if (--loadingCount === 0) $rootScope.$broadcast('loading:finish')
      return response || $q.when(response)
    },

    responseError: (response) => {
      if (--loadingCount === 0) $rootScope.$broadcast('loading:finish')
      return $q.reject(response)
    },
  }
}

export default httpInterceptor



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/interceptors/httpInterceptor.js